export const backgroundStyle: React.CSSProperties = {
  // background: 'linear-gradient(270deg, #FFB6C1, #FFDAB9, #B0E0E6)',
  // backgroundSize: '600% 600%',
  // animation: 'Gradient 15s ease infinite',
  // height: '100%',
  // width: '100%',
  // position: 'fixed',
  // top: 0,
  // left: 0,
  // zIndex: -1
}
